import React from 'react'
import { connect } from 'react-redux'
import { Route } from 'react-router-dom'

import ProfileNav from '../components/ProfileNav'
import UserProfileContainer from './UserProfileContainer'
import AffiliationChangeContainer from './AffiliationChangeContainer'
import ContactInformationContainer from './ContactInformationContainer'

import '../style/profile.scss'

const ProfileContainer = ({ user, location, match, serverProperties }) =>
  <div className='lgy-profile' data-testid="profileGear">
    <div className='usa-grid' data-testid="profileNav">
      {!user.exists ?
        <h3>Loading...</h3>
        :
        <div>
          <div className='usa-width-one-fourth'>
            <Route path='/lgyhub/profile'><ProfileNav isAffiliate={user.isAffiliate} location={location} match={match} user={user} /></Route>
          </div>
          <div className='usa-width-three-fourths'>
            <Route exact path='/lgyhub/profile' component={UserProfileContainer} />
            <Route exact path='/lgyhub/profile/contact' component={ContactInformationContainer} />
            {user.isAffiliate && <Route exact path='/lgyhub/profile/affiliation'><AffiliationChangeContainer user={user} location={location} serverProperties={serverProperties}/></Route>}
          </div>
        </div>
      }
    </div>
  </div>

const mapStateToProps = (state) => ({
  user: state.currentUser,
  serverProperties : state.serverProperties
})

export default connect(mapStateToProps)(ProfileContainer)
